import ExampleModule from '~/repositories/gtm/modules/example'
import ContentModule from '~/repositories/gtm/modules/content'
import ContentGroupModule from '~/repositories/gtm/modules/contentGroup'
import SearchRequestsModule from '~/repositories/gtm/modules/searchRequests'
import SearchResultsModule from '~/repositories/gtm/modules/searchResults'
import InquiriesModule from '~/repositories/gtm/modules/inquiries'
import ProductsModule from '~/repositories/gtm/modules/products'
import PricesModule from '~/repositories/gtm/modules/prices'
import MapsModule from '~/repositories/gtm/modules/maps'
import FormsModule from '~/repositories/gtm/modules/forms'
import DatepickerModule from '~/repositories/gtm/modules/datepicker'
import FiltersModule from '~/repositories/gtm/modules/filters'
import MietwagenModule from '~/repositories/gtm/modules/mietwagen'

export function createGtmModules () {
  return {
    example: new ExampleModule(),
    content: new ContentModule(),
    contentGroup: new ContentGroupModule(),
    searchRequests: new SearchRequestsModule(),
    searchResults: new SearchResultsModule(),
    inquiriesModule: new InquiriesModule(),
    productsModule: new ProductsModule(),
    pricesModule: new PricesModule(),
    mapsModule: new MapsModule(),
    formsModule: new FormsModule(),
    datepickerModule: new DatepickerModule(),
    filtersModule: new FiltersModule(),
    mietwagen: new MietwagenModule()
  }
}
